module.exports = __webpack_public_path__ + "media/react/components/UI/Logo/images/FindMe2careLogo-05339eb97bbd0dcc06654f18ae414c47.svg";